import { FETCH_MIX_API } from "../../constants/mixapi";
import { feeds } from "../../apis/services";

export const fetchMixAPI = () => {
  return {
    type: FETCH_MIX_API,
    payload: feeds.getMixAPI(),
  };
};
